import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import ReactTooltip from "react-tooltip";
import Alert from "react-bootstrap/Alert";
import * as DOMPurify from 'dompurify';
import { myUtilities, myGlobals } from "../../Utils";
import { globalVars } from "../../App";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { InvoiceElements } from "./";

class InvoiceDiv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeletedAlert: false,
      showTermsAndConditions: false,
      method: "ACH",
      toShowEditWindow: false,
    };
    this.myref = React.createRef();
  }
  toggleTermsAndConditionsCheckbox = (bool, method = "ACH") => {
    this.setState({
      showTermsAndConditions: bool,
      method: method,
    });
  };
  showAlert = (invData) => {
    if (
      invData.state.deletedInvoices !== undefined &&
      invData.state.deletedInvoices !== null &&
      invData.state.deletedInvoices.length > 0 &&
      !this.state.showDeletedAlert
    ) {
      setTimeout(() => {
        this.setState({
          showDeletedAlert: true,
        });
      }, 5000);
      return (
        <Alert className="my-alert-class" variant="danger">
          <p>
            {myUtilities.accountSpecificLanguage("Alert.InvoiceNumbers", "Invoice Number(s)")}
            : {invData.state.deletedInvoices} <br />
            {myUtilities.accountSpecificLanguage("Alert.InvoiceRemoval", "has/have been removed because it/they are not payable")}
          </p>
        </Alert>
      );
    }
  };
  showCurrency = (data) => {
    return (
      <Row>
        <Col className="top-margin-negative">
          <InvoiceElements
            header={
              <div className="separated-children-ends">
                <div className="invoice-div-sub-heading">
                  {myUtilities.accountSpecificLanguage(
                    "Header.currency",
                    "Currency")}
                  :
                </div>
                {data.insertCurrencySymbol()}
              </div>
            }
            value=""
          />
        </Col>
      </Row>
    );
  };
  showDiscountAmount = (data) => {
    if (data.state.totalDiscVal !== null && myGlobals.isDiscountEnabled)
      return (
        <Row>
          <Col className="top-margin-negative">
            <InvoiceElements
              header={
                <div className="separated-children-ends">
                  <div className="invoice-div-sub-heading">
                    {myUtilities.accountSpecificLanguage("Header.IncludesDiscountAmount"
                      ,"Applied Discounts")}
                    :
                  </div>
                  {myUtilities.needCurrency("discountAmount") +
                	  myUtilities.toStringUtil(data.state.totalDiscVal, 'discountAmount')}
                </div>
              }
              value=""
            />
          </Col>
        </Row>
      );
    else return null;
  };
  showConvenienceFee = (data) => {
    if (data.state.totalConvienceFee !== null)
      return (
        <Row>
          <Col className="top-margin-negative">
            <InvoiceElements
              header={
                <div className="separated-children-ends">
                  <div className="invoice-div-sub-heading">
                    {myUtilities.accountSpecificLanguage("Header.IncludesConvenienceFee"
                      ,"Includes Convenience Fee"
                    )}
                    :
                  </div>
                  {myUtilities.needCurrency("totalConvienceFee") +
                	  myUtilities.toStringUtil(data.state.totalConvienceFee, 'totalConvienceFee')}
                </div>
              }
              value=""
            />
          </Col>
        </Row>
      );
    else return null;
  };
  showSurchargeAmount = (data) => {
    if (data.state.totalSurchargeAmount !== null)
      return (
        <Row>
          <Col className="top-margin-negative">
            <InvoiceElements
              header={
                <div className="separated-children-ends">
                  <div className="invoice-div-sub-heading">
                    {myUtilities.accountSpecificLanguage("Header.IncludesSurcharge"
                      ,"Includes Surcharge Amount")}
                    :
                  </div>
                  {myUtilities.needCurrency("totalSurchargeAmount") +
                	  myUtilities.toStringUtil(data.state.totalSurchargeAmount, 'totalSurchargeAmount')}
                </div>
              }
              value=""
            />
          </Col>
        </Row>
      );
    else return null;
  };
  showLateFee = (data, invdata) => {
    if (invdata.state.paymentOnAccount !== undefined && !invdata.state.paymentOnAccount && invdata.state.isLateFeeEnabled !== undefined && invdata.state.isLateFeeEnabled && data.state.totalLateFee !== undefined && data.state.totalLateFee !== null && data.state.totalLateFee > 0)
      return (
        <Row>
          <Col className="top-margin-negative">
            <InvoiceElements
              header={
                <div className="separated-children-ends">
                  <div className="invoice-div-sub-heading">
                    {myUtilities.accountSpecificLanguage("Header.IncludesLateFee"
                      ,"Includes Late Fee")}
                    :
                  </div>
                  {myUtilities.needCurrency("totalLateFee") +
                	  myUtilities.toStringUtil((data.state.totalLateFee === undefined || data.state.totalLateFee === null) ? 0 : data.state.totalLateFee, 'totalLateFee')}
                </div>
              }
              value=""
            />
          </Col>
        </Row>
      );
    else return null;
  };
  showInvoiceGridAndTotal = (invdata) => {
    if (invdata.state.paymentOnAccount) return null;
    else
      return (
        <React.Fragment>
          <Row>
            <Col className="top-margin">
              <InvoiceElements
                header={
                  myUtilities.accountSpecificLanguage("Header.InvoiceQuantity"
                    ,"Number of Invoices")
                }
                value="count"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <InvoiceElements
                alterEditState={this.viewEditWindow}
                toshowEditWindow={this.state.toShowEditWindow}
                header={
                  <Row className="invoice-list-hyperlink-row">
                    <Col className="invoice-div-payable-col" xs={9}>
                    {myUtilities.accountSpecificLanguage("Header.Grid.Heading"
                        ,"Payable Invoices")}
                    </Col>
                    <Col xs={3}>
                      {invdata.state.allowInvoiceExclusion && (
                        <button
                          className="view-more-invoices-button"
                          onClick={() => {
                            this.viewEditWindow(true);
                          }}
                        >
                          {myUtilities.accountSpecificLanguage(
                            "InvoiceGrid.Change",
                             "Change")
                          }
                        </button>
                      )}
                    </Col>
                  </Row>
                }
                isGrid
              />
            </Col>
          </Row>
        </React.Fragment>
      );
  };
  viewEditWindow = (bool) => {
    this.setState({
      toShowEditWindow: bool,
    });
  };

  showEditIcon = (data) => {
    if (data.state.paymentOnAccount) {
      let minAmount = data.state.minAmount;
      let maxAmount = data.state.maxAmount;
      let payableAmount = data.state.payableAmount;
      if (minAmount === parseFloat(0) && maxAmount === parseFloat(0)) {
        return false;
      }
      if (
        maxAmount === parseFloat(payableAmount) &&
        minAmount === parseFloat(payableAmount)
      )
        return false;
      else return true;
    } else return false;
  };

  showAdditionalParams = (invdata) => {
    if (invdata.state.paymentOnAccount) {
      let result = [];
      invdata.state.additionalParams.forEach((obj) => {
        result.push(
          <InvoiceElements
            isPlain
            key={obj.key}
            header={obj.displayName}
            value={obj.value}
          />
        );
      });
      return result;
    }
  };

  showSurchargeNote = (invdata) => {
    if (invdata.state.isCCEnabled === true && invdata.state.isSurchargeEnabledOnCC === true && (myGlobals.paymentMethod === "CREDITCARD" || myGlobals.paymentMethod === "cc")) {
      return (
        <Row className="">
          <Col className="">
            <div>
              <div className="text-danger small-font ml-2 mt-2">
						  {(() => {
							  if (
								  (invdata.state.isSurchargeThroughAPIEnabled === true && invdata?.state?.isSurchargeApplicableForTransaction != undefined) || invdata.state.isSurchargeEnabledOnCardBrand === true
							  ) {
								  if (
									  invdata.state.isSurchargeThroughAPIEnabled === true && invdata.state.isSurchargeApplicableForTransaction === true
								  ) {
									  if (
										  invdata?.state?.surchargePOEDisclosure != undefined &&
										  invdata?.state?.surchargePOEDisclosure != null &&
										  invdata?.state?.surchargePOEDisclosure != ""
									  ) {
										  return invdata.state.surchargePOEDisclosure;
									  } else {
										  return myUtilities.accountSpecificLanguage(
											  "Note.IncludesSurchargeNote",
											  "NOTE: Based on the card you add, there might be an additional surcharge fee added to the total transaction amount as applicable, which will be shown in the next step."
										  );
									  }
								  } else if (invdata.state.isSurchargeThroughAPIEnabled === true && invdata.state.isSurchargeApplicableForTransaction === false) {
									  return "";
								  } else if (invdata.state.isSurchargeEnabledOnCardBrand === true) {
									  return myUtilities.accountSpecificLanguage(
										  "Note.IncludesSurchargeNote",
										  "NOTE: Based on the card you add, there might be an additional surcharge fee added to the total transaction amount as applicable, which will be shown in the next step."
									  );
								  }
							  }
                })()}
              </div>
            </div>
          </Col>
        </Row>
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invdata) => (
              <Container className="no-padding-container">
                <div className="payment-summary-header">
                {myUtilities.accountSpecificLanguage("Header.PaymentSummary"
		                ,"Payment Summary")}
                </div>
                {this.showAlert(invdata)}

                <Row className="no-gutter invoice-div-container">
                  <Col className="no-padding-container">
                    <Container id="invoice-div-id" className="invoice-div">
                      <Row>
                        <Col className="top-margin">
                          <InvoiceElements
                          	addClass = "amount-main"
                            header={
                              myUtilities.accountSpecificLanguage("Header.totalamt"
                                ,"Total Amount")
                            }
                            showEditIcon={this.showEditIcon(invdata)}
                            value="total"
                          />
                        </Col>
                      </Row>
                      {this.showCurrency(invdata)}
                      {this.showDiscountAmount(invdata)}
                      {this.showConvenienceFee(data)}
                      {this.showSurchargeAmount(data)}
                      {this.showLateFee(data, invdata)}
                      {this.showAdditionalParams(invdata)}
                      {this.showInvoiceGridAndTotal(invdata)}
                      {this.showSurchargeNote(invdata)}
                    </Container>
                  </Col>
                </Row>
              </Container>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
  componentDidMount = () => {
    globalVars.showTermsAndConditions = this.toggleTermsAndConditionsCheckbox;
  };

  componentDidUpdate(prevProps) {
    if (!this.state.toShowEditWindow) ReactTooltip.rebuild();
  }
}

export default InvoiceDiv;
